module.exports = __webpack_public_path__ + "static/media/hesa-espoo.0299c23e.svg";